import script from "./AlgorithmMode.vue?vue&type=script&setup=true&lang=js"
export * from "./AlgorithmMode.vue?vue&type=script&setup=true&lang=js"

import "./AlgorithmMode.vue?vue&type=style&index=0&id=24a12d25&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a12d25"]])

export default __exports__